wbApp.filter('wbColor', ['$sce',
    function ($sce) {
        return function (input) {
            var colorUtils = new webooker_utils.ColorUtils();

            return $sce.trustAsHtml('<div style="background-color:' + colorUtils.intToRgb(input || 0) + '; width: 100%; height: 18px; padding: 1px;"></div>');
        }
}]);